// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2IH7E","colCheckbox":"styles_colCheckbox__1BHjg"};